export default {
  setting: [],
  booths: [],
  storeOptions: [],
  branchUserPersons: [],
  stores: [],
  boothList: [],
  preOrders: [],
  preOrderById: null,
  shopSaleFactors: [],
  cashClosings: [],
  cashClosingCartable: [],
  cashClosingManagementCartable: [],
  userStores: [],
  salePanelGroups: [],
  orderSettlementTypes: [],
  activePosTerminals: [],
  activeBenefitCards: [],
  printLink: null,
};
